export const STORES_STORAGE_KEY = 'stores'
